module.exports = __webpack_public_path__ + "media/assets/images/lib/select2-c07457739c183c845cacbf55dae2808e.png";